import React, { memo } from 'react'
import FormattedPhoneNumber from 'transfix-ui/components/FormattedPhoneNumber'
import { IParentUserProps } from 'apps/marketplace/apiTypes/parentUsers'
import { TableRow, TableCell } from 'transfix-ui'
import { formatDate } from 'utils/formatDatetime'
import { DISPLAY } from 'constants/display'

interface IUserRowProps {
  user: IParentUserProps
  defaultSet?: boolean
}

export const UserRow = memo<IUserRowProps>(({ defaultSet, user }) => {
  const { companyDetails = [], applicationUser = {} } = user || {}
  const createdAt = applicationUser.createdAt || user.createdAt
  const typeName = applicationUser.typeName || user.typeName
  const stateName = applicationUser.stateName || user.stateName

  const companyDetailsCell = () => {
    if (!companyDetails.length) return DISPLAY.empty
    return companyDetails.map(company => {
      const key = `${company.applicationId}-${user.id}`
      return (
        <div key={key}>
          <a
            href={`${__ROOT__}/${company.applicationTypePath}/${company.applicationId}`}
            target='_blank'
            rel='noopener noreferrer'>
            {company.applicationName}
          </a>
        </div>
      )
    })
  }

  const name =
    user.firstName || user.lastName ? `${user.firstName} ${user.lastName}` : DISPLAY.empty

  return (
    <TableRow>
      <TableCell>
        <a href={`${__ROOT__}/users/${user.id}`} target='_blank' rel='noopener noreferrer'>
          {name}
        </a>
      </TableCell>
      <TableCell>{formatDate(createdAt, 'dateFormat') || DISPLAY.empty}</TableCell>
      <TableCell>{user.email || DISPLAY.empty}</TableCell>
      <TableCell>
        {user.phone ? (
          <div key={`phone-${user.phone}`}>
            P: <FormattedPhoneNumber phoneNumber={user.phone} />
            {user.phoneExt ? `Ext: +${user.phoneExt}` : ''}
          </div>
        ) : (
          ''
        )}
        {user.cellPhone ? (
          <div key={`cellPhone-${user.cellPhone}`}>
            C: <FormattedPhoneNumber phoneNumber={user.cellPhone} />
          </div>
        ) : (
          ''
        )}
        {(!user.cellPhone && !user.phone) ?? DISPLAY.empty}
      </TableCell>
      <TableCell>{typeName || DISPLAY.empty}</TableCell>
      <TableCell>{user.id}</TableCell>
      <TableCell>{stateName || DISPLAY.empty}</TableCell>
      {!defaultSet && <TableCell>{companyDetailsCell()}</TableCell>}
    </TableRow>
  )
})
